import { render, staticRenderFns } from "./ProductContentView.vue?vue&type=template&id=04d9d9f7&scoped=true&"
import script from "./ProductContentView.vue?vue&type=script&lang=js&"
export * from "./ProductContentView.vue?vue&type=script&lang=js&"
import style0 from "./ProductContentView.vue?vue&type=style&index=0&id=04d9d9f7&prod&scoped=true&lang=css&"
import style1 from "./ProductContentView.vue?vue&type=style&index=1&id=04d9d9f7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d9d9f7",
  null
  
)

export default component.exports